import { getPubliEnabled, setPubliEnabled } from '../infrastructure/site-config.repository.js';

/**
 * Servicio de flag de publi para el panel de staff. Orquesta el repositorio
 * (I/O) y devuelve un modelo simple `{ enabled }`; no conoce el SDK de
 * Supabase — eso vive en `site-config.repository.js`.
 */

/**
 * Carga el estado actual del flag de publi.
 *
 * @returns {Promise<{ enabled: boolean }>}
 * @throws {Error} si el repositorio falla
 */
export async function loadPubli() {
    const enabled = await getPubliEnabled();
    return { enabled };
}

/**
 * Cambia el flag de publi al valor indicado.
 *
 * @param {boolean} next — nuevo valor
 * @returns {Promise<{ enabled: boolean }>}
 * @throws {Error} si el repositorio falla
 */
export async function togglePubli(next) {
    await setPubliEnabled(next);
    return { enabled: next };
}
